export const LOAD_SECURE_CONTENT = 'LOAD_SECURE_CONTENT'
export const LOADING_SECURE_CONTENT = 'LOADING_SECURE_CONTENT'
export const LOAD_SECURE_CONTENT_SUCCEEDED = 'LOAD_SECURE_CONTENT_SUCCEEDED'
export const LOAD_SECURE_CONTENT_FAILED = 'LOAD_SECURE_CONTENT_FAILED'


export function loadSecureContent(name) {
    return { type: LOAD_SECURE_CONTENT, payload: name }
}
